import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';

import './Dealer.css';

class MeldingenUsersNoInvoiceBase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading:false,
      users:[],
      uid: '',
      user: '',
      company:'',
    };
  }

  componentDidMount() {
    this.setState({
      loading:true
    });

    if (!this.props.dealerName) {
      this.setState({ loading: false });
      return;
    }

    this.usersQuery = this.props.firebase.usersByDealer(this.props.dealerName);
    this.usersQuery.on('value', snapshot => {
      this.setState({
        users: this.props.firebase.snapshotToList(snapshot),
        loading: false,
      });
    });
  }

  componentWillUnmount() {
    if (this.usersQuery) {
      this.usersQuery.off();
    }
  }

  render() {
    const { users, loading } = this.state;

    return (
        <div>
        <div className="Dealer-klanten">
          <h2>Definitieve factuur nog uploaden</h2>
          {loading && <div>Loading...</div>}
          <table className="Tabel-full-width">
            <tbody>
              <tr>
                <th>Naam</th><th>E-mailadres</th><th>Telefoonnummer</th><th>Bedrijf</th><th>Definitieve factuur geupload</th><th>Details</th>
              </tr>
              {users
                .filter(user => {
                  return !user.downloadUrl
                })
                .map(user => (
                  <tr key={user.uid}>
                      <td>{user.username}</td>
                      <td>{user.email}</td>
                      <td>{user.phoneNumber}</td>
                      <td>{user.company}</td>
                      {user.downloadUrl && <td>Ja</td>}
                      {!user.downloadUrl && <td className="Rood">Nee</td>}
                      <td><Link to={{
                        pathname: `${ROUTES.DEALER}/user/${user.uid}`,
                        state: { user },
                      }}
                      >
                        <strong>Details</strong>
                      </Link></td>

                  </tr>
              ))}

            </tbody>
          </table>
      </div>
      </div>
    )
  }
}

export default MeldingenUsersNoInvoiceBase;
